var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroDecal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "411px",
    height: "536px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(223, 241, 47)",
    d: "M326.946,535.145 L198.972,535.145 L282.179,441.175 L0.442,84.772 L0.442,0.053 L62.239,0.053 L410.640,440.689 L326.946,535.145 ZM140.580,535.145 L11.147,535.145 L94.354,441.663 L0.442,323.835 L0.442,162.188 L223.301,441.175 L140.580,535.145 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroDecal);
export default __webpack_public_path__ + "static/media/hero_decal.774acd117289f532a91446d593db70e5.svg";
export { ForwardRef as ReactComponent };